"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type === _packagesConstants.PACKAGES_LOADED) {
    var name = action.packageJson.name;
    // If we already know about this package, do nothing.
    if (state.packages.find(function (pkg) {
      return pkg.name === name;
    })) {
      return state;
    }
    // Otherwise, add it to development controls.

    return _extends({}, state, {
      packages: [].concat(_toConsumableArray(state.packages), [{
        name: name,
        status: "STOPPED",
        active: false
      }]).sort(function (a, b) {
        return a.name > b.name ? 1 : -1;
      })
    });
  }

  if (action.type === _packagesConstants.PACKAGES_START) {
    return _extends({}, state, {
      packages: state.packages.map(function (pkg) {
        if (action.pkgName === pkg.name) {
          return _extends({}, pkg, {
            status: "STARTED",
            active: true
          });
        }
        return pkg;
      })
    });
  }

  if (action.type === _packagesConstants.PACKAGES_STOP) {
    return _extends({}, state, {
      packages: state.packages.map(function (pkg) {
        if (action.pkgName === pkg.name) {
          return _extends({}, pkg, {
            status: "STOPPED",
            active: false
          });
        }
        return pkg;
      })
    });
  }

  if (action.type === _configConstants.CONFIG_LOADED) {
    return _extends({}, state, {
      env: _extends({}, action.configData.env)
    });
  }

  if (action.type === _developmentConstants.DEVELOPMENT_LOG) {
    var newObject = {
      appName: action.pkgName,
      color: (0, _colors.getColor)(action.pkgName),
      date: Date.now(),
      serverStatus: "",
      uid: action.uid,
      expectedAction: action.text
    };
    return Object.assign({}, state, {
      logs: [].concat(_toConsumableArray(state.logs.slice(-999)), [newObject])
    });
  }

  if (action.type === _developmentConstants.DEVELOPMENT_ENV_CHANGE) {
    var variableName = action.variableName,
        currentValue = action.currentValue;


    return _extends({}, state, {
      env: _extends({}, state.env, _defineProperty({}, variableName, _extends({}, state.env[variableName], {
        currentValue: currentValue
      })))
    });
  }

  if (action.type === _serverConstants.SERVER_ERROR) {
    var _newObject = {
      appName: "wheelhouse",
      date: Date.now(),
      serverStatus: "",
      uid: action.notification.uid,
      expectedAction: action.notification.message,
      color: (0, _colors.getColor)("wheelhouse")
    };
    return Object.assign({}, state, { logs: [].concat(_toConsumableArray(state.logs), [_newObject]) });
  }

  if (action.type === _serverConstants.SERVER_UPDATE) {
    var _newObject2 = {
      appName: action.updateInfo.name,
      date: Date.now(),
      serverStatus: "",
      uid: action.uid,
      expectedAction: action.message,
      color: (0, _colors.getColor)(action.updateInfo.name)
    };
    return Object.assign({}, state, { logs: [].concat(_toConsumableArray(state.logs), [_newObject2]) });
  }
  return state;
};

var _developmentConstants = require("./developmentConstants");

var _packagesConstants = require("../packages/packagesConstants");

var _serverConstants = require("../server/serverConstants");

var _colors = require("../util/colors");

var _configConstants = require("../config/configConstants");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  packages: [],
  logs: []
};
//# sourceMappingURL=developmentReducer.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/development/developmentReducer.js
// module id = 244
// module chunks = 0